import React, { useState, useEffect } from 'react';
import validate from '../../../utils/validate';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import DeleteAccountModal from './DeleteAccountModal'

import './styles.scss';

import {
  Container,
  Button,
  TextField,
  Paper,
  Grid,
  Typography,
} from '@material-ui/core';

import MenuAppBar from '../../../App/Components/AppBar/AppBar';
import AppFooter from '../../../App/Components/AppFooter/AppFooter';

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function UserProfile(props: any) {
  const [openConfirmationModal, setOpenConfirmationModal] = React.useState(false);
  const [credentials, setCredentials] = useState(
    { email: '', firstName: '', lastName: '', company: '', webAddress: '', location: '', description: '', contactEmail: '' })
  const [errors, setErrors] = useState({} as any)
  const [showBanner, setShowBanner] = useState('')

  setTimeout(function () { setShowBanner('') }, 5000);

  const { getIssuer, auth } = props;

  useEffect(() => {
    getIssuer(auth.user.attributes.email).then((r: any) => {
      if (r.status === 200) {
        const issuer = r.data.issuer;
        setCredentials({
          ...credentials,
          email: issuer.email_address,
          firstName: issuer.first_name,
          lastName: issuer.last_name,
          company: issuer.organization_name,
          webAddress: issuer.web_address,
          location: issuer.location,
          description: issuer.description,
          contactEmail: issuer.second_email_address
        })
      } else {
      }
    })
  }, [])

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setCredentials({
      ...credentials,
      [name]: value
    });
  }

  const isEmptyObject = (obj: any) => Object.getOwnPropertyNames(obj).length == 0

  const updateAccount = (e: any) => {
    e.preventDefault()
    const validation = validate('updateAccount', credentials);

    setErrors({
      ...errors,
      email: validation.email,
      firstName: validation.firstName,
      lastName: validation.lastName,
      webAddress: validation.webAddress,
      contactEmail: validation.contactEmail,
    })

    if (!isEmptyObject(validation)) {
      setShowBanner('error');
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    } else {
      props.updateIssuer({
        issuer_email: props.auth.user.attributes.email,
        issuer_first_name: credentials.firstName,
        issuer_last_name: credentials.lastName,
        organization: credentials.company,
        web_address: credentials.webAddress,
        // company: credentials.company,
        location: credentials.location,
        description: credentials.description,
        second_email_address: credentials.contactEmail
      })
        .then((r: any) => {
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
          setShowBanner('success')
          props.getDashboardInfo().then((r: any) => console.log('dashboard info updated'))
        }, (e: any) => { })
        .catch((e: any) => {
          setShowBanner('error')
          console.error('e', e)
        })
    }
  }

  const handleOpenConfirmDelete = (e: any) => {
    e.preventDefault();
    setOpenConfirmationModal(true);
  }
  const handleConfirmDelete = () => {
    props.deleteIssuer(props.auth.user.attributes.email).then((r: any) => setOpenConfirmationModal(false))
  }

  const handleCancel = () => {
    setOpenConfirmationModal(false);
  }

  return (
    <>
      <MenuAppBar logout={props.logout} />
      <Container className='root userInfo'>
        {showBanner === 'success' && (
          <Alert severity="success" className='successAlert'>Your account has been updated!</Alert>
        )}
        {showBanner === 'error' && (
          <Alert severity="error" className='errorAlert'>Your account was not updated!</Alert>
        )}
        <Grid item xs={12} sm={12} md={8} lg={8} component={Paper}
          elevation={6} square className="flex center userGrid">
          <div className="userProfileInfo title">
            <Typography component="h2" variant="h6" className='bold'>Update Account Information</Typography>
          </div>
          <form className='form' noValidate>
            <TextField
              error={errors.email ? true : false}
              value={credentials.email}
              onChange={e => handleChange(e)}
              id={errors.email ? "outlined-error-helper-text" : "email"}
              label={errors.email ? "Error" : "Email Address"}
              helperText={errors.email ? `${errors.email}` : ''}
              variant="outlined"
              margin="normal"
              fullWidth
              name="email"
              disabled={true}
              autoComplete="email"
            />
            <TextField
              error={errors.firstName ? true : false}
              value={credentials.firstName}
              onChange={e => handleChange(e)}
              id={errors.firstName ? "outlined-error-helper-text" : "firstName"}
              label={errors.firstName ? "Error" : "First Name"}
              helperText={errors.firstName ? `${errors.firstName}` : ''}
              variant="outlined"
              margin="normal"
              fullWidth
              name="firstName"
              type="text"
              autoComplete="firstName"
            />
            <TextField
              error={errors.lastName ? true : false}
              value={credentials.lastName}
              onChange={e => handleChange(e)}
              id={errors.lastName ? "outlined-error-helper-text" : "lastName"}
              label={errors.lastName ? "Error" : "Last Name"}
              helperText={errors.lastName ? `${errors.lastName}` : ''}
              variant="outlined"
              margin="normal"
              fullWidth
              name="lastName"
              type="text"
              autoComplete="lastName"
            />
            <TextField
              onChange={e => handleChange(e)}
              value={credentials.company}
              label='Company'
              variant="outlined"
              margin="normal"
              fullWidth
              name="company"
              type="text"
              autoComplete="company"
            />
            <TextField
              onChange={e => handleChange(e)}
              label='Location'
              value={credentials.location}
              variant="outlined"
              margin="normal"
              fullWidth
              name="location"
              type="text"
              autoComplete="location"
            />
            <TextField
              onChange={e => handleChange(e)}
              label='Description'
              value={credentials.description}
              variant="outlined"
              margin="normal"
              fullWidth
              multiline
              name="description"
              type="text"
              autoComplete="description"
            />
            <TextField
              error={errors.webAddress ? true : false}
              value={credentials.webAddress}
              onChange={e => handleChange(e)}
              id={errors.webAddress ? "outlined-error-helper-text" : "webAddress"}
              label={errors.webAddress ? "Error" : "Web Address"}
              helperText={errors.webAddress ? `${errors.webAddress}` : ''}
              variant="outlined"
              margin="normal"
              fullWidth
              name="webAddress"
              type="text"
              autoComplete="webAddress"
            />
            <TextField
              error={errors.contactEmail ? true : false}
              value={credentials.contactEmail}
              onChange={e => handleChange(e)}
              id={errors.contactEmail ? "outlined-error-helper-text" : "contactEmail"}
              label={errors.contactEmail ? "Error" : "Contact Email Address"}
              helperText={errors.contactEmail ? `${errors.contactEmail}` : ''}
              variant="outlined"
              margin="normal"
              fullWidth
              name="contactEmail"
              autoComplete="contactEmail"
            />
            <div className="actions userInfoActions">
              <Button
                type="submit"
                variant="contained"
                className='submit red-bck white update'
                onClick={(e) => updateAccount(e)}
              >
                Update Account Info
              </Button>
              <Button
                type="submit"
                variant="contained"
                className='submit white-bck red delete'
                onClick={(e) => handleOpenConfirmDelete(e)}
              >
                Delete Account
              </Button>
            </div>
          </form>
        </Grid>
        <DeleteAccountModal showModal={openConfirmationModal} onConfirm={handleConfirmDelete} onCancel={handleCancel} />
      </Container>
      <AppFooter />
    </>
  );
}